import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import PreviewChild from './PreviewChild';

export default class PreviewRoot extends Component {
  static propTypes = {
    nodes: PropTypes.array.isRequired,
  };

  render() {
    const { nodes } = this.props;

    return (
      <Fragment>
        {nodes.map((node, index) => {
          return (
            <PreviewChild
              key={`${index}`}
              node={node}
              parentType={'root'}
              parentIndex={`${index}`}
            />
          );
        })}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PreviewVDOM/PreviewRoot.js